"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNodeModuleVarsCaptureTemplate = getNodeModuleVarsCaptureTemplate;
function getNodeModuleVarsCaptureTemplate() {
    return `
        // Capture Node.js module-scoped variables (require, module, exports, __filename, __dirname)
        (function() {
            if (!{vmGlobalsName}.require) {
                try { {vmGlobalsName}.require = require; } catch (e) {}
            }
            if (!{vmGlobalsName}.module) {
                try { {vmGlobalsName}.module = module; } catch (e) {}
            }
            if (!{vmGlobalsName}.exports) {
                try { {vmGlobalsName}.exports = exports; } catch (e) {}
            }
            if (!{vmGlobalsName}.__filename) {
                try { {vmGlobalsName}.__filename = __filename; } catch (e) {}
            }
            if (!{vmGlobalsName}.__dirname) {
                try { {vmGlobalsName}.__dirname = __dirname; } catch (e) {}
            }
        })();`;
}
